<template>
    <div>
        <div class="d-flex" id="wrapper">
            <!-- Sidebar -->
            <SideBar/>
            <!-- /#sidebar-wrapper -->
            <!-- Page Content -->
            <div id="page-content-wrapper">
                <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                    <div>
                        <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                        </button>

                        <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                        </button>
                    </div>
                    <div class="d-flex">
                        <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
                        <p class="text-primary mb-0 hover-cursor">&nbsp;Product</p>
                    </div>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                            <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  {{ admin }}
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                    <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                    <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 grid-margin stretch-card card-div">
                            <div class="container">
                                <h5 class="card-title mb-4"> Product List </h5>
                                <div class="d-flex mb-2 flex-wrap">
                                    <div class="mr-2">
                                        <button class="btn btn-primary mt-4" @click="openModal('Add')"> Add New</button>
                                    </div>
                                    <div class="mr-2" style="width: 150px;">
                                        Product Type
                                        <multiselect v-model="searchType" :options="productType" label="productTypeName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Product Type" track-by="productTypeName"></multiselect>
                                    </div>
                                    <div class="mr-2" style="width: 200px;">
                                        Product Category
                                        <multiselect v-model="searchCategory" :options="productCategory" label="productCategory" :allow-empty="false" :select-label="'Category'" :deselect-label="''" placeholder="Product Category" track-by="productCategory"></multiselect>
                                    </div>
                                    <div class="mr-2" style="width: 320px;">
                                        Product Name
                                        <input type="text" name="" class="form-control" placeholder="Product Name" v-model="searchProductName">
                                    </div>
                                    <div class="mr-2" style="width: 159px;">
                                        Product Status
                                        <multiselect v-model="searchStatus" :options="productStatusSelect" label="statusName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Product Status" track-by="statusName"></multiselect>
                                    </div>
                                    <div>
                                        <button class="btn btn-primary mt-4" @click="searchData"> Search </button>
                                        <button class="btn btn-primary mt-4" @click="searchData"> Reset </button>
                                    </div>
                                </div>
                                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                    <thead class="">
                                        <tr>
                                            <th style="width : 100px;">Product ID</th>
                                            <th>Type</th>
                                            <th>Category</th>
                                            <th>Product Name</th>
                                            <th>Specification</th>
                                            <th>Status</th>
                                            <th style="width: 110px;">Show Order</th>
                                            <th style="width: 190px;">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="loadingTable === false && totalData == '0'">
                                            <td colspan="8" class="text-center">Data Not Available</td>
                                        </tr>
                                        <tr v-else-if="loadingTable === true">
                                            <td colspan="8" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                        </tr>
                                        <tr v-for="(data,index) in dataProduct" :key="index" v-else>
                                            <td>{{ data.productId }}</td>
                                            <td>{{ data.brand }}</td>
                                            <td>{{ data.brand }}</td>
                                            <td>{{ data.productTitle}}</td>
                                            <td>{{ data.specifications }}</td>
                                            <td>
                                                <label class="badge badge-danger" v-if="data.productStatus == '0'">Inactive</label>
                                                <label class="badge badge-success" v-if="data.productStatus == '1'">Active</label>
                                            </td>
                                            <td>{{ data.showingOrder }}</td>
                                            <td>
                                                <button class="btn btn-warning btn-sm" @click="openModal('ShowSetting',data.productId, data.productTitle)" v-if="data.topProduct == null"> Show </button>
                                                <button class="btn btn-warning btn-sm" disabled v-else> <i class="fa fa-trophy" aria-hidden="true"></i> </button>
                                                <button class="btn btn-success btn-sm" @click="toProductEditPage('data.ProductId', 'unit')"> Edit </button>
                                                <button class="btn btn-primary btn-sm" @click="openModal('Change',data.productId, data.productStatus, data.productTitle, data.productCategory, data.showingOrder, data.productType)"> Inactive </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex">
                                        <div style="margin-right: 10px;">
                                        <select class="form-control form-control-sm" v-model="itemPerPage" @change="showPage()">
                                                <option value="10">10</option>
                                                <option value="40">40</option>
                                                <option value="80">80</option>
                                        </select>
                                        </div>
                                        <div class="total-data align-self-center">
                                            Total Data {{ totalData }}
                                        </div>
                                    </div>
                                    <div>
                                        <div class="pagination p8 alignRight">
                                            <ul>
                                                <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1">
                                                    <li>
                                                        {{'<'}}
                                                    </li>
                                                </a>
                                                <a class="page">
                                                    <li>{{ currentPage }} of {{ totalPage }} page</li>
                                                </a>
                                                <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage">
                                                    <li>></li>
                                                </a>
                                            </ul>
                                        </div>
                                    </div>
                                </div>​
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /#page-content-wrapper -->
            <div class="modal fade" id="modalShowSetting" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Show Settings</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <label>Top Product Setting :</label>
                            <div class="d-flex">
                                <label class="ml-4 field-label">Top Product</label>
                                <div class="w-100">
                                    <input type="radio" v-model="productTypeAdd" value="unit" class="link ml-2">
                                    <label>Yes</label>
                                    <input type="radio" v-model="productTypeAdd" value="bundling" class="link ml-2">
                                    <label>No</label>
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <span class="ml-4 field-label">Replacing</span>
                                <multiselect v-model="searchType" :options="productType" label="productTypeName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Product Type" track-by="productTypeName"></multiselect>
                            </div>
                            <label class="mt-4">Showing Order Setting :</label>
                            <div class="d-flex align-items-center">
                                <span class="ml-4 field-label">Show Order</span>
                                <multiselect v-model="searchType" :options="productType" label="productTypeName" :allow-empty="false" :select-label="'Type'" :deselect-label="''" placeholder="Product Type" track-by="productTypeName"></multiselect>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary btn-sm" :disabled="loadingButtonNext" @click="nextAdd(productTypeAdd)"><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingButtonNext">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="modalAdd" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Add Product</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <label>Please choose what you want to add</label><br>
                            <input type="radio" v-model="productTypeAdd" value="unit" class="link">
                            <label>Unit Product</label><br>
                            <input type="radio" v-model="productTypeAdd" value="bundling" class="link">
                            <label>Bundling Product</label>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary btn-sm" :disabled="loadingButtonNext" @click="nextAdd(productTypeAdd)"><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingButtonNext">Next</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- mudalToTop -->
            <div class="modal fade" id="modalToTop" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Add To Top Products</h4>
                                <h5 class="modal-title">{{ productNameChoose }}</h5>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure to add this product to top product?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitTopProduct">Save</button>
                            <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;">Save</button>

                        </div>
                    </div>
                </div>
            </div>
            <!-- endModal -->
            <!-- mudalChangeStatus -->
            <div class="modal fade" id="modalChange" role="dialog">
                <div class="modal-dialog modal-dialog-centered">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="change-title">
                                <h4 class="modal-title">Change Status</h4>
                            </div>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body">
                            <p>Are you sure want to set {{ productNameChoose }} inactive?</p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary btn-sm" v-if="loadingButtonProcess == false" @click="submitChangeStatus">Save</button>
                            <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;">Save</button>

                        </div>
                    </div>
                </div>
            </div>
            <!-- endModal -->
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
export default {
    name: 'ProductPage',
    components: {
        SideBar,
        Multiselect
    },
    data() {
        return {
            spaceRegex: /[\u00A0\uFEFF\u202F]/g, 
            admin: "",
            adminId: "",
            permission: [],
            viewDashboard: false,
            viewOrder: false,
            viewReturn: false,
            viewProduct: false,
            viewPairing: false,
            viewReconcile: false,
            viewResolution: false,
            viewLessor: false,
            viewLessee: false,
            viewEmployee: false,
            editOrder: false,
            editReturn: false,
            editProduct: false,
            editPairing: false,
            editReconcile: false,
            editResolution: false,
            editLessor: false,
            editLessee: false,
            editEmployee: false,
            loadingButtonProcess: false,
            loadingButtonNext: false,
            dataProduct: [],
            dataSearchProduct: [],
            totalPage: 0,
            totalData: 0,
            currentPage: 1,
            orderId: "",
            companyName: "",
            statusOrder: "",
            loadingTable: true,
            productBrand: [],
            productBrandSearch: [],
            productSpec: [],
            productIdChoose: '',
            productNameChoose: '',
            statusChoose: '',
            searchBrand: 'All',
            search: false,
            searchCategory: {
                productCategory: 'All'
            },
            productCategory: [],
            searchType: {
                productType: 'All',
                productTypeName: 'All'
            },
            productType: [],
            brandSelect: [],
            searchProductName: '',
            allShowing: [],
            categoryShowing: [],
            showingChoose: '',
            typeChoose: '',
            itemPerPage: 10,
            searchStatus:{
                status:'All',
                statusName:'All'
            },
            productStatusSelect:[
            {
               status:'All',
               statusName:'All' 
            },
            {
               status:'1',
               statusName:'Active' 
            },
            {
               status:'0',
               statusName:'Inactive' 
            },
            ],
            productTypeAdd:'unit'
        }
    },
    methods: {
            nextAdd(page){
                this.loadingButtonNext = true
                if (page.toLowerCase() == 'unit') {
                    this.toPage('/product/add/unit')
                }else if (page.toLowerCase() == 'bundling') {
                    this.toPage('/product/add/bundling')
                }
            },
            toProductEditPage(productId, typeProduct){
              this.$router.push({path:'/product/edit/'+typeProduct,
                    query: {
                        productId: productId,
                    }
                })
            },
            // toProductCatalogPage(){
            //   this.$router.push({path:'/product',
            //         query: {
            //             productType: 'All',
            //             productTypeName: 'All',
            //             productCategory: 'All',
            //             productBrand: 'All',
            //             productStatus: 'All',
            //             productStatusName: 'All',
            //             productName: '',
            //             itemPerPage: 10,
            //             page:1
            //         }
            //     })
            // },
            submitTopProduct() {
                this.loadingButtonProcess = true
                this.$http.post(process.env.ADD_TOP_PRODUCT, {
                        productId: this.productIdChoose,
                        adminId: this.adminId
                    }, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                        } else if (response.data.status == 200) {
                            swal("Success", response.data.message, "success", {
                                button: "Ok",
                            })
                            $('#modalToTop').modal('hide')
                            this.sendLog(this.productIdChoose,31)
                            this.getData()
                            this.loadingButtonProcess = false
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
            },
            openModal(x, y, z, a, b, c, d) {
                this.productIdChoose = y
                this.statusChoose = z
                this.productNameChoose = a
                console.log(x)
                if (x == 'ToTop') {
                    this.productNameChoose = z
                } else if (x == 'Change') {
                    for (var i = 0; i < this.allShowing.length; i++) {
                        if (this.allShowing[i]["type"] == b) {
                            this.categoryShowing = this.allShowing[i]["showingOrder"]
                        }
                    }
                    this.showingChoose = c
                    this.typeChoose = b
                }

                $("#modal" + x).modal('show')
            },
            searchData() {
                let productType = ''
                let productTypeName = ''
                let productCategory = ''
                if (this.searchType != null) {
                    if (this.searchType.length != 0) {
                        productType = this.searchType.productType
                        productTypeName = this.searchType.productTypeName
                    }
                }
                if (this.searchCategory != null) {
                    if (this.searchCategory.length != 0) {
                        productCategory = this.searchCategory.productCategory
                    }
                }
                if (this.searchBrand == null) {
                    this.searchBrand = ''
                }

                this.$router.push({path:'/product', query: {
                        productType: productType,
                        productTypeName: productTypeName,
                        productCategory: productCategory,
                        productBrand: this.searchBrand,
                        productStatus: this.searchStatus.status,
                        productStatusName: this.searchStatus.statusName,
                        productName: this.searchProductName,
                        itemPerPage: this.itemPerPage,
                        page:1
                    }
                })
                this.getData();
            },
            showPage(){
                let productType = ''
                let productTypeName = ''
                let productCategory = ''
                if (this.searchType != null) {
                    if (this.searchType.length != 0) {
                        productType = this.searchType.productType
                        productTypeName = this.searchType.productTypeName
                    }
                }
                if (this.searchCategory != null) {
                    if (this.searchCategory.length != 0) {
                        productCategory = this.searchCategory.productCategory
                    }
                }
                if (this.searchBrand == null) {
                    this.searchBrand = ''
                }
                this.$router.push({path:'/product', query: {
                        productType: productType,
                        productTypeName: productTypeName,
                        productCategory: productCategory,
                        productBrand: this.searchBrand,
                        productStatus: this.searchStatus.status,
                        productStatusName: this.searchStatus.statusName,
                        productName: this.searchProductName,
                        itemPerPage: this.itemPerPage,
                        page:1
                    }
                })
                this.getData();
            },
            toDataPage(pagePost) {
                this.loadingTable = true
                let productType = ''
                let productTypeName = ''
                let productCategory = ''
                if (this.searchType != null) {
                    if (this.searchType.length != 0) {
                        productType = this.searchType.productType
                        productTypeName = this.searchType.productTypeName
                    }
                }
                if (this.searchCategory != null) {
                    if (this.searchCategory.length != 0) {
                        productCategory = this.searchCategory.productCategory
                    }
                }
                if (this.searchBrand == null) {
                    this.searchBrand = ''
                }
                this.$router.push({path:'/product', query: {
                        productType: productType,
                        productTypeName: productTypeName,
                        productCategory: productCategory,
                        productBrand: this.searchBrand,
                        productStatus: this.searchStatus.status,
                        productStatusName: this.searchStatus.statusName,
                        productName: this.searchProductName,
                        itemPerPage: this.itemPerPage,
                        page:pagePost
                    }
                })
                this.getData();
            },
            toPage(e) {
                this.$router.push(e)
            },
            async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
                localStorage.removeItem('jwt')
                localStorage.removeItem('admin_name')
                localStorage.removeItem('roles')
                localStorage.removeItem('user_email')
                localStorage.removeItem('admin_id')
                localStorage.removeItem('changeCatalogPermission')
                this.$router.push('/')
            },
            cekLogin() {
                if (localStorage.getItem('jwt') == null) {
                    this.$router.push('/')
                }
            },
            cekPermission() {
                this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
                for (var i = 0; i < this.permission.length; i++) {
                    if (this.permission[i] == "1") {
                        this.viewDashboard = true
                    }
                    if (this.permission[i] == "2.1") {
                        this.viewOrder = true
                    }
                    if (this.permission[i] == "2.2") {
                        this.editOrder = true
                    }
                    if (this.permission[i] == '3.1') {
                        this.viewReturn = true
                    }
                    if (this.permission[i] == '3.2') {
                        this.editReturn = true
                    }
                    if (this.permission[i] == '4.1') {
                        this.viewProduct = true
                    }
                    if (this.permission[i] == '4.2') {
                        this.editProduct = true
                    }
                    if (this.permission[i] == '5.1') {
                        this.viewPairing = true
                    }
                    if (this.permission[i] == '5.2') {
                        this.editPairing = true
                    }
                    if (this.permission[i] == '6') {
                        this.viewReconcile = true
                    }
                    if (this.permission[i] == '7.1') {
                        this.viewResolution = true
                    }
                    if (this.permission[i] == '7.2') {
                        this.editResolution = true
                    }
                    if (this.permission[i] == '8.1') {
                        this.viewLessor = true
                    }
                    if (this.permission[i] == '8.2') {
                        this.editLessor = true
                    }
                    if (this.permission[i] == '9.1') {
                        this.viewLessee = true
                    }
                    if (this.permission[i] == '9.2') {
                        this.editLessee = true
                    }
                    if (this.permission[i] == '10') {
                        this.viewEmployee = true
                    }
                }
                if (this.viewProduct == false) {
                    this.$router.push('/')
                }
            },
            sidebar() {
                $("#wrapper").toggleClass("toggled");
            },
            toDetail(id) {
                this.$router.push('/product/detail/' + id)
            },
            getData(){
                this.loadingTable = true
                if (this.$route.query.productType != '') {
                    this.searchType = {
                        productType: this.$route.query.productType,
                        productTypeName: this.$route.query.productTypeName
                    }
                } else {
                    this.searchType = null
                }
                if (this.$route.query.productCategory != '') {
                    this.searchCategory = {
                        productCategory: this.$route.query.productCategory
                    }
                }
                if (this.$route.query.productStatus != '') {
                    this.searchStatus = {
                        status: this.$route.query.productStatus,
                        statusName: this.$route.query.productStatusName
                    }
                } else {
                    this.searchStatus = null
                }
                this.searchBrand = this.$route.query.productBrand
                this.searchProductName = this.$route.query.productName
                this.itemPerPage = this.$route.query.itemPerPage
                this.currentPage = parseInt(this.$route.query.page)
                this.$http.post(process.env.SEARCH_PRODUCT, {
                        productType: this.$route.query.productType,
                        productCategory: this.$route.query.productCategory,
                        productBrand: this.searchBrand !== null ? this.searchBrand.replace(this.spaceRegex, ' ') : this.searchBrand,
                        productStatus: this.$route.query.productStatus,
                        productName: this.searchProductName !== null ? this.searchProductName.replace(this.spaceRegex, ' ') : this.searchProductName,
                        page: this.$route.query.page,
                        itemPerPage: this.itemPerPage
                    }, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                        } else {
                            this.dataProduct = response.data.content.data
                            this.productBrand = []
                            this.productSpec = []
                            this.totalPage = response.data.content.totalPage
                            this.currentPage = response.data.content.currentPage
                            this.totalData = response.data.content.totalData
                            this.allShowing = response.data.content.allShowing
                            this.loadingTable = false
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                            this.handleLogout()
                            }
                        })
                    })

                this.$http.get(process.env.GET_CATEGORY, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        this.productType=[]
                        this.productCategory=[]
                        this.brandSelect=[]
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                        } else {
                            this.productType.push({
                                productType: 'All',
                                productTypeName: 'All',
                            })
                            for (var i = 0; i < response.data.content.productType.length; i++) {
                                this.productType.push({
                                    productType: response.data.content.productType[i].productType,
                                    productTypeName: response.data.content.productType[i].productTypeName
                                })
                            }
                            this.productCategory.push({
                                productCategory: 'All'
                            })
                            for (var i = 0; i < response.data.content.productCategory.length; i++) {
                                this.productCategory.push({
                                    productCategory: response.data.content.productCategory[i].productCategory
                                })
                            }
                            this.brandSelect = ['All']
                            for (var i = 0; i < Object.values(response.data.content.productBrand).length; i++) {
                                this.brandSelect.push(Object.values(response.data.content.productBrand)[i])
                            }
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
            },
            submitChangeStatus() {
                this.loadingButtonProcess = true
                this.$http.post(process.env.CHANGE_CATALOG_STATUS, {
                        productId: this.productIdChoose,
                        newStatus: this.statusChoose,
                        newShowing: this.showingChoose,
                        productCategory: this.typeChoose,
                        adminId: this.adminId
                    }, {
                        headers: {
                            'Asani-Token': localStorage.getItem('jwt')
                        }
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                            })
                        } else if (response.data.status == 200) {
                            swal("Success", response.data.message, "success", {
                                button: "Ok",
                            })
                            $('#modalChange').modal('hide')
                            if (response.data.content.changeShowing == 'yes') {
                                this.sendLog(this.productIdChoose,34)
                            }
                            if (response.data.content.changeStatus == 0) {
                                this.sendLog(this.productIdChoose,32)
                            }
                            if (response.data.content.changeStatus == 1) {
                                console.log('masuk aktive')
                                this.sendLog(this.productIdChoose,33)
                            }
                            this.getData()
                            this.loadingButtonProcess = false
                        }
                    })
                    .catch(error => {
                        swal("Sorry", error.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
            },
            sendLog(x,y){
                var today = new Date();
                var month = today.getMonth()+1
                if (month < 10) {
                    month = '0'+month
                }
                var dateDay = today.getDate()
                if (dateDay < 10) {
                    dateDay = '0'+dateDay
                }
                var hours = today.getHours()
                if (hours < 10) {
                    hours = '0'+hours
                }
                var minutes = today.getMinutes()
                if (minutes < 10) {
                    minutes = '0'+minutes
                }
                var second = today.getSeconds()
                if (second < 10) {
                    second = '0'+second
                }
                var date = today.getFullYear()+'-'+month+'-'+dateDay;
                var time = hours + ":" + minutes + ":" + second;
                var dateTime = date+' '+time;
                var admin = this.admin
                var command = 'add-logs'
                var productName = this.productNameChoose !== null ? this.productNameChoose.replace(this.spaceRegex, ' ') : this.productNameChoose
                if (y == '34') {
                    var newShowing = this.showingChoose
                    this.$http.post(process.env.LOG_URL+"/product/"+x,{
                        codeLogs: y,
                        params: [productName, newShowing],
                    },{
                        headers: {'Asani-Token':localStorage.getItem('jwt')}
                    })
                    .then(response => {
                    })
                    .catch(error => {
                        console.log(error)
                    })
                }else{
                    this.$http.post(process.env.LOG_URL+"/product/"+x,{
                        codeLogs: y,
                        params: [productName],
                    },{
                        headers: {'Asani-Token':localStorage.getItem('jwt')}
                    })
                    .then(response => {
                    })
                    .catch(error => {
                        console.log(error)
                    })
                }
            }
    },
    created() {
        this.getData()
        this.admin = localStorage.getItem('admin_name')
        this.adminId = localStorage.getItem('admin_id')
        this.cekLogin()
        this.cekPermission()
    }
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .field-label{
        width: 160px;
    }

    .pagination{
        padding: 0px 0;
    }

    .pagination ul{
        margin: 0;
        padding: 0;
        list-style-type: none;
    }

    .pagination a{
        display: inline-block;
        padding: 1px 6px;
        color: #222;
    }

    .p8 a{
        background-color: #2797FB;
        color: #fff;
        border: 1px solid #2797FB;
    }

    .p8 a:hover{
        text-decoration: none;
    }
    .p8 a.page:hover{
        text-decoration: none;
        color: #fff;
    }

    .p8 .is-active{
        background-color: #fff;
        color: #2797FB;
    }

    .total-data{
        font-size: 14px;
        color: #343A40;
    }

    .right-dropdown{
        margin-left: 7px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductPage.vue